import React from 'react';
import dayjs from 'dayjs';
import FilterDropdown from '../../../shared/components/filter/FilterDropdown';
import { useTranslation } from 'react-i18next';

interface PaymentFiltersProps {
  selectedDateRange: [string, string] | null;
  selectedPaymentStatus: string;
  selectedPlanType: string;
  onDateRangeChange: (dates: [string, string] | null) => void;
  onPaymentStatusChange: (status: string) => void;
  onPlanTypeChange: (planType: string) => void;
  onReset: () => void;
}

const PaymentFilters: React.FC<PaymentFiltersProps> = ({
  selectedDateRange,
  selectedPaymentStatus,
  selectedPlanType,
  onDateRangeChange,
  onPaymentStatusChange,
  onPlanTypeChange,
  onReset,
}) => {
  const { t } = useTranslation();

  const filterGroups = [
    {
      label: 'Tarih Aralığı',
      type: 'dateRange' as const,
      value: selectedDateRange ? [dayjs(selectedDateRange[0]), dayjs(selectedDateRange[1])] : null,
      onChange: (dates: any) => {
        if (dates) {
          onDateRangeChange([dates[0].toISOString(), dates[1].toISOString()]);
        } else {
          onDateRangeChange(null);
        }
      }
    },
    {
      label: 'Ödeme Durumu',
      type: 'select' as const,
      value: selectedPaymentStatus,
      onChange: onPaymentStatusChange,
      options: [
        { value: '', label: 'Tüm Durumlar' },
        { value: 'paid', label: 'Ödendi' },
        { value: 'pending', label: 'Beklemede' },
        { value: 'failed', label: 'Başarısız' },
        { value: 'refunded', label: 'İade Edildi' }
      ]
    },
    {
      label: 'Plan Türü',
      type: 'select' as const,
      value: selectedPlanType,
      onChange: onPlanTypeChange,
      options: [
        { value: '', label: 'Tüm Planlar' },
        { value: 'basic', label: 'Temel' },
        { value: 'premium', label: 'Premium' },
        { value: 'enterprise', label: 'Kurumsal' },
        { value: 'trial', label: 'Deneme' }
      ]
    }
  ];

  return (
    <FilterDropdown
      groups={filterGroups}
      onReset={onReset}
      className="me-2"
      buttonType="primary"
      icon="ti ti-filter"
    />
  );
};

export default PaymentFilters;